<template>
    <div class="myOrder" >
        <a-tabs defaultActiveKey="1" >
            <a-tab-pane tab="全部订单" :forceRender="forceRender" key="1">
                <order-list status="-1" ref="orderList1" @refresh="refresh" :class="{'my-order-mobile':isMobile}"/>
            </a-tab-pane>

            <a-tab-pane tab="等待付款" :forceRender="forceRender" key="2">
                <order-list status="0" ref="orderList2" @refresh="refresh" :class="{'my-order-mobile':isMobile}"/>
            </a-tab-pane>

            <a-tab-pane tab="付款成功" :forceRender="forceRender" key="3">
                <order-list status="1" ref="orderList3" @refresh="refresh" :class="{'my-order-mobile':isMobile}"/>
            </a-tab-pane>

        </a-tabs>

    </div>
</template>

<script>
    import OrderList from '@components/order/OrderList'
    import common from "@/mixin/common";
    export default {
        name: "MyOrder",
      mixins: [common],
      components: {
            OrderList
        },
        data() {
            return{
                forceRender: true
            }
        },
        methods: {
            refresh() {
                // console.log(e)
                this.$refs.orderList1.initData()
                this.$refs.orderList2.initData()
                this.$refs.orderList3.initData()
            }
        }
    }
</script>

<style scoped lang="less">
/deep/ .ant-tabs-nav-wrap{
  background: #fff;
}
.my-order-mobile{
  margin: 0 13px ;
}
    .myOrder{
        /*padding: 20px 0;*/
    }
</style>
